import { defineMessages } from 'react-intl';

const messages = defineMessages({
  software: {
    id: 'r3C4x/',
    defaultMessage: 'Software',
  },
  advanced: {
    id: '3Rx6Qo',
    defaultMessage: 'Advanced',
  },
  if_advance_is_selected221: {
    id: '18sekZ',
    defaultMessage:
      'This tool then incorporates detailed storage and infrastructure information to generate annual benefits.',
  },
  if_advance_is_selected222: {
    id: '9zbFc2',
    defaultMessage: 'With IBM Fusion, you could see annual savings of ',
  },
  max_servers_per_admin_tooltip: {
    id: 'GY0iIm',
    defaultMessage:
      'Typical admin managing servers, storage, and network can manage up X servers',
  },
  see_your_results: {
    id: 'XFvtVb',
    defaultMessage: 'Get Your Report',
  },
  application_availablity: {
    id: 'kuZMQG',
    defaultMessage:
      'What are the application availability and data resilience strategies are most important to you?',
  },
  zip_code: {
    id: 'GlHK2F',
    defaultMessage: 'Zip / Postal Code',
  },
  x_small: {
    id: 'FqSYiw',
    defaultMessage: 'X-small',
  },
  abstract_text3: {
    id: 'X1Ujdq',
    defaultMessage:
      'IBM Fusion has emerged as a forward-thinking solution designed to help organizations modernize their applications and infrastructure. It seamlessly integrates with OpenShift to surpass traditional hyperconverged infrastructure (HCI) solutions while introducing cutting-edge generative AI capabilities through the IBM watsonx.data platform. Not only does IBM Fusion reduce total cost of ownership (TCO) for VMware customers, but it also empowers on-premises application platforms by separating control and self-service functionalities. Managed clusters effortlessly provision workers on virtualized Fusion system servers, enabling self-service via APIs. With IBM Fusion, organizations can realize significant TCO savings by eliminating software licensing complexities and optimizing compute efficiency on bare metal, all while positioning themselves for a path of modernization.',
  },
  hardware: {
    id: '9gyxgq',
    defaultMessage: 'Hardware',
  },
  abstract_text1: {
    id: '2YFwzx',
    defaultMessage:
      'Managing infrastructure costs in a rapidly changing world can be particularly challenging. How do you continue to support day-to-day operations that rely upon legacy applications and infrastructure while modernizing both? According to Scott Sinclair, Practice Director of Infrastructure, Cloud, and DevOps art Enterprise Strategy Group:',
  },
  databases: {
    id: 'RYbE1p',
    defaultMessage: 'Databases',
  },
  large: {
    id: '/06iwc',
    defaultMessage: 'Large',
  },
  if_advance_is_selected212: {
    id: 'cwKgmO',
    defaultMessage:
      ' of your workloads are Windows VMs. Enterprise Strategy Group',
  },
  if_advance_is_selected213: {
    id: 'moOupw',
    defaultMessage:
      'validated assumptions are used to estimate and model computations in each savings category.',
  },
  if_advance_is_selected211: {
    id: 'EcjcsI',
    defaultMessage: 'Additionally, you indicated that ',
  },
  page_title1: {
    id: '+28KD+',
    defaultMessage: 'See how much you could save with',
  },
  page_title2: {
    id: 'dRQRi+',
    defaultMessage: 'IBM Fusion',
  },
  agree: {
    id: 'G9mGax',
    defaultMessage: 'I agree to the',
  },
  number_of_Vms: {
    id: '/xxglw',
    defaultMessage: 'Number of VMs',
  },
  messaging: {
    id: '87optu',
    defaultMessage: 'Messaging',
  },
  crash_consistent: {
    id: 'P7V35o',
    defaultMessage: 'Crash consistent backup and restore',
  },
  the_solution: {
    id: 'bCwkzR',
    defaultMessage: 'The Solution - IBM Fusion HCI',
  },
  footer2_text11: {
    id: 'oNWJEF',
    defaultMessage:
      ' TechTarget, Inc. or its subsidiaries. All rights reserved. TechTarget, and the TechTarget logo, are trademarks or registered trademarks of',
  },
  number_of_infrastructure_admins_tooltip: {
    id: 'L6tk1t',
    defaultMessage: 'Total admins.',
  },
  footer2_text12: {
    id: 'bv7zPx',
    defaultMessage:
      'TechTarget, Inc. and are registered in jurisdictions worldwide. Other product and service names and logos, including for BrightTALK, Xtelligent, and the Enterprise Strategy Group might be trademarks of TechTarget or its subsidiaries. All other trademarks, logos and brand names are the property of their respective owners.',
  },
  number_of_infrastructure_admins: {
    id: 'sT5C5E',
    defaultMessage: 'Number of infrastructure admins',
  },
  web_server: {
    id: 'KjBgzA',
    defaultMessage: 'Web Servers',
  },
  if_advance_is_not_selected13: {
    id: 'voJ6We',
    defaultMessage:
      'machines. Enterprise Strategy Group validated assumptions are used to estimate and model computations in each savings category. This tool then incorporates detailed storage and infrastructure information to generate annual benefits. With IBM Fusion, you could see annual savings of',
  },
  if_advance_is_not_selected12: {
    id: 'Q0VmJW',
    defaultMessage: ' virtual',
  },
  more_info: {
    id: 'GeBgRz',
    defaultMessage: 'For More Information',
  },
  if_advance_is_not_selected11: {
    id: 'cQo/ce',
    defaultMessage:
      'Based on your provided inputs, this tool assumes that your organization currently has ',
  },
  abstract_text21: {
    id: '4cfhyu',
    defaultMessage:
      '“Application modernization offers one of the best opportunities to create a more agile and more innovative business. The adoption of containers provides advantages to scalability, infrastructure independence, and empowers developers to create superior code. That being said, not every app is ready or should be prioritized for modernization. With containers and virtual machines likely coexisting across hybrid cloud environments for the foreseeable future, organizations should prioritize simplifying these environments to a single platform, one that can span both on and off-premises infrastructure, to reduce the burden on internal admins. ',
  },
  current: {
    id: 'fF376U',
    defaultMessage: 'Current',
  },
  total_savings: {
    id: 'L5X3Lc',
    defaultMessage: 'Total Annual Savings',
  },
  other_source2text: {
    id: 'di1UPD',
    defaultMessage:
      'Navigating the Cloud and AI Revolution: The State of Enterprise Storage and HCI',
  },
  see_your_result: {
    id: 'chl/Fd',
    defaultMessage: 'Download Personalized Report',
  },
  max_servers_per_admin: {
    id: '8dXouz',
    defaultMessage: 'Max servers per admin',
  },
  currency: {
    id: '55hdQy',
    defaultMessage: 'Currency',
  },
  email: {
    id: 'sy+pv5',
    defaultMessage: 'Email',
  },
  support_Maintenance: {
    id: 'VIUEM+',
    defaultMessage: 'Support Maintenance',
  },
  application_availablity_tooltip: {
    id: 'mc2IZl',
    defaultMessage:
      'Please select the application availability and data resilience strategies are most important to you.',
  },
  current_vm_Workload_tooltip: {
    id: 'DXVV2f',
    defaultMessage:
      'Please enter the current mix of your VM load. The total must equal 100%',
  },
  infrastructure_and_administration: {
    id: '8gKDGI',
    defaultMessage: 'Infrastructure and Administration',
  },
  number_of_Vms_tshirt: {
    id: 'Z1ktTP',
    defaultMessage: 'Number of VMs T-shirt sizing',
  },
  infrastructure_admin_annual_salary_tooltip2: {
    id: 'rXo7Sd',
    defaultMessage:
      'https://www.salary.com/research/salary/posting/server-administrator-salary',
  },
  last_name: {
    id: 'aheQdn',
    defaultMessage: 'Last Name',
  },
  percentage_of_your_workload: {
    id: '0BH/v8',
    defaultMessage:
      'What percentage of your workloads do you intend to containerize in the next 2 years?',
  },
  abstract: {
    id: 'E2iRvp',
    defaultMessage: 'Abstract',
  },
  header_text1: {
    id: '1OKaF2',
    defaultMessage:
      'Realize Cost Benefits and Optimize Efficiency Using IBM Fusion HCI on Red Hat OpenShift',
  },
  type_of_storage_tooltip: {
    id: 'HC9/Np',
    defaultMessage: 'Please select your organizations type of storage.',
  },
  loading_report: {
    id: 'TbazV9',
    defaultMessage: 'Loading Report...',
  },
  infrastructure_admin_annual_salary_tooltip1: {
    id: 'aH4De2',
    defaultMessage: 'Source',
  },
  download_report_link_loading: {
    id: 'DmXaFJ',
    defaultMessage: 'Loading document...',
  },
  small: {
    id: 'BPnT3T',
    defaultMessage: 'Small',
  },
  mix_of_windows_tooltip: {
    id: 'jaYujs',
    defaultMessage:
      'There is extra licensing costs with Windows that need to be accounted for. In order to get you a proper calculation please slide the bar to indicate your percentage of Windows VMs.',
  },
  report_header: {
    id: 'PwOiiy',
    defaultMessage:
      'Realize Cost Benefits and Optimize Efficiency Using IBM Fusion with Red Hat OpenShift',
  },
  with_ibm: {
    id: 'I4oLT/',
    defaultMessage: 'With IBM',
  },
  number_of_Vms_note_link: {
    id: 'hniz8Z',
    defaultMessage: 'here',
  },
  percentage_of_your_workload_tooltip: {
    id: 'sfCHDB',
    defaultMessage:
      'Please enter the percentage of workloads containerized in the next 2 years.',
  },
  application_consistent: {
    id: 'Ok02GU',
    defaultMessage: 'Application consistent backup and restore',
  },
  your_result: {
    id: '2WWihC',
    defaultMessage: 'Your Results',
  },
  x_large: {
    id: '/dtKuL',
    defaultMessage: 'X-large',
  },
  if_advance_is_selected11: {
    id: 'SKqQ2A',
    defaultMessage: 'This tool assumes your organization has ',
  },
  metro_disaster_recovery: {
    id: '5u2RLo',
    defaultMessage: 'Metro disaster recovery',
  },
  if_advance_is_selected13: {
    id: '/aGvIu',
    defaultMessage: 'that your VM T-shirt sizing is as follows:',
  },
  if_advance_is_selected12: {
    id: '+1fT9D',
    defaultMessage: ' virtual machines based on your inputs. You indicated ',
  },
  data_analysis: {
    id: 'n7m92O',
    defaultMessage: 'Data Analytics',
  },
  reset_default: {
    id: 'Jmgbho',
    defaultMessage: 'Reset Defaults',
  },
  total_Vms: {
    id: 'cslOfj',
    defaultMessage: 'Total Vms:',
  },
  job_title: {
    id: 'w7sjvQ',
    defaultMessage: 'Job Title',
  },
  ibm_flashsystem: {
    id: 'GDKVdQ',
    defaultMessage: 'IBM FlashSystem',
  },
  esgibm_fusion: {
    id: '07Q7Kd',
    defaultMessage: 'ESG IBM Fusion',
  },
  mix_of_windows: {
    id: 'HuODul',
    defaultMessage: 'What % of workloads are Windows VMs?',
  },
  your_result_text: {
    id: 'qhuTCJ',
    defaultMessage:
      'Enterprise Strategy Group, a division of TechTarget, analyzed and distilled information from various sources, including IBM technical and business assets, Enterprise Strategy Group’s knowledge and expertise in economics and infrastructure solutions, publicly available industry information, and the results of the economic validation process, created a tool to calculate the annual benefits seen by implementing IBM Fusion HCI. This tool quantifies the benefits your organization could see when implementing the IBM Fusion HCI solution by computing the inputs you have provided from the tool to calculate the associated benefit.',
  },
  al_ml: {
    id: 'gByx+3',
    defaultMessage: 'AI/ML',
  },
  the_solution_text: {
    id: '3W3ssX',
    defaultMessage:
      'IBM Fusion HCI is a hyperconverged infrastructure solution engineered for the simple and streamlined deployment of OpenShift. Leveraging the power of Fusion, this turnkey enterprise-grade offering easily connects with OpenShift, removing the external hypervisor. Thus, the environment is managed through a single point of control—not two. VMs and containers are managed as equal first-class citizens in the OpenShift environment, benefiting from optimized, shared resources.',
  },
  regional_disaster_recovery: {
    id: 'zYs0mR',
    defaultMessage: 'Regional disaster recovery',
  },
  accept_assumption: {
    id: 'dEPvQ5',
    defaultMessage: 'Accept Assumptions',
  },
  footer2_text2: {
    id: 'rh1WQ9',
    defaultMessage:
      'Information contained in this publication has been obtained by sources TechTarget considers to be reliable but is not warranted by TechTarget. This publication may contain opinions of TechTarget, which are subject to change. This publication may include forecasts, projections, and other predictive statements that represent TechTarget’s assumptions and expectations in light of currently available information. These forecasts are based on industry trends and involve variables and uncertainties. Consequently, TechTarget makes no warranty as to the accuracy of specific forecasts, projections or predictive statements contained herein.',
  },
  footer2_text3: {
    id: 'TSWHHx',
    defaultMessage:
      'Any reproduction or redistribution of this publication, in whole or in part, whether in hard-copy format, electronically, or otherwise to persons not authorized to receive it, without the express consent of TechTarget, is in violation of U.S. copyright law and will be subject to an action for civil damages and, if applicable, criminal prosecution. Should you have any questions, please contact Client Relations at',
  },
  footer2_text4: {
    id: '6p22HX',
    defaultMessage: 'About Enterprise Strategy Group',
  },
  medium: {
    id: 'ovJ26C',
    defaultMessage: 'Medium',
  },
  if_advance_is_not_selected2: {
    id: 'TQh2FW',
    defaultMessage:
      'The results predicted that by implementing IBM Fusion HCI, your organization will see benefits of:',
  },
  conclusion_text2: {
    id: 'c9vIU/',
    defaultMessage: 'is right for your organizational needs.',
  },
  conclusion_text1: {
    id: 'AFqTKM',
    defaultMessage:
      'Enterprise Strategy Group validated the methodology and findings of the IBM Fusion TCO analysis. This comparison emphasizes the efficient operation on OCP bare metal, the cost-saving elimination of hypervisor and guest OS expenses, enhanced efficiency, and simplified operations. If your organization is looking to save costs, boost performance, and provide flexibility for your IT environment, Enterprise Strategy Group recommends that you evaluate whether',
  },
  ibm_agree: {
    id: 'K5lPFF',
    defaultMessage: 'IBM Website Terms & Conditions of Use.',
  },
  conclusion: {
    id: 'ZjlBPk',
    defaultMessage: 'Conclusion',
  },
  infrastructure_admin_annual_salary: {
    id: '06GHov',
    defaultMessage: 'Infrastructure admin annual salary',
  },
  total: {
    id: 'MJ2jZQ',
    defaultMessage: 'Total',
  },
  footer_text2: {
    id: 'DGyxGq',
    defaultMessage: ' {year} TechTarget, Inc. All Rights Reserved.',
  },
  footer_text1: {
    id: 'Q9eVM3',
    defaultMessage:
      'This Enterprise Strategy Group Economic Summary was commissioned by IBM and is distributed under license from TechTarget, Inc.',
  },
  number_of_Vms_note1: {
    id: 'X6qJ+M',
    defaultMessage: 'Click',
  },
  company: {
    id: '9YazHG',
    defaultMessage: 'Company',
  },
  number_of_Vms_note2: {
    id: 'Vw95FI',
    defaultMessage: 'for more than 50,000 VMs',
  },
  download_report: {
    id: 'NVSlJX',
    defaultMessage:
      'If your report does not download automatically, click the link below.  You can also download the report later by using the View Your Report button.',
  },
  type_of_storage: {
    id: 'vIV1FC',
    defaultMessage: 'Type of storage',
  },
  Snapshots: {
    id: '4y3rEL',
    defaultMessage: 'Snapshots',
  },
  first_name: {
    id: 'Q6wcZ5',
    defaultMessage: 'First Name',
  },
  other_source1text: {
    id: '7f1cE6',
    defaultMessage:
      'Enterprise Strategy Group Research Report: Understanding Workload, App, and Data Deployment and Migration Decision-making',
  },
  footer2_website: {
    id: 'EvGRpz',
    defaultMessage: 'www.esg-global.com',
  },
  annual_administrative_savings: {
    id: 'Te3UfP',
    defaultMessage: 'Annual Administrative Savings',
  },
  informationa_purposes: {
    id: '6Q6ozs',
    defaultMessage: 'Additional Optional Information',
  },
  download_report_link: {
    id: 'iHdvdj',
    defaultMessage: 'Download Report',
  },
  view_your_report: {
    id: 'qu5DT+',
    defaultMessage: 'View Your Report',
  },
  other_source1: {
    id: 'Uwvn7B',
    defaultMessage:
      'Source: Enterprise Strategy Group Complete Survey Results:',
  },
  select_one: {
    id: 'wuVrZj',
    defaultMessage: 'Select One',
  },
  abstract_text223: {
    id: '9JVQoP',
    defaultMessage:
      '” Scott Sinclair, Practice Director, Enterprise Strategy Group',
  },
  abstract_text222: {
    id: 'EU4h77',
    defaultMessage:
      'In a time when, 91% of organizations agree that data center modernization is strategic and can provide a competitive advantage, modernization on-premises should be a priority.',
  },
  infrastructure: {
    id: 'dA+hnZ',
    defaultMessage: 'Infrastructure',
  },
  footer2_text5: {
    id: 'VUxdzJ',
    defaultMessage:
      'TechTarget’s Enterprise Strategy Group provides focused and actionable market intelligence, demand-side research, analyst advisory services, GTM strategy guidance, solution validations, and custom content supporting enterprise technology buying and selling',
  },
  footer2_contact2: {
    id: 'tjN1Q3',
    defaultMessage: 'contact@esg-global.com',
  },
  abstract_text221: {
    id: 'sFO1qs',
    defaultMessage:
      'Enterprise Strategy Group research finds that 72% of organizations run business-critical applications in a hybrid cloud application environment that can offer a consistent orchestration layer, such as IBM Fusion with Red Hat OpenShift.',
  },
  footer2_contact1: {
    id: 'XU8Hbl',
    defaultMessage: 'cr@esg-global.com',
  },
  view_modify_assumption: {
    id: 'uouW3z',
    defaultMessage: 'View / Modify Model Assumptions',
  },
  with_ibm_fusion: {
    id: 'p6OMNF',
    defaultMessage: 'With IBM Fusion HCI',
  },
  other_source2: {
    id: 'DjzAit',
    defaultMessage:
      'Source: Enterprise Strategy Group Complete Survey Results,',
  },
});

export default messages;
